import ApplicantViewSegment from "./ApplicantViewSegment.component.jsx";

export default ApplicantViewSegment;